module.exports = __webpack_public_path__ + "common/tp-featured6-3c4a3ee228cca737d258cdddcd702976.svg";